// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pictrue[data-v-945b1358]{width:60px;height:60px;border:1px dotted rgba(0,0,0,.1);margin-right:10px;position:relative;cursor:pointer}.pictrue img[data-v-945b1358]{width:100%;height:100%}.btndel[data-v-945b1358]{position:absolute;z-index:1;width:20px !important;height:20px !important;left:43px;top:1px}", ""]);
// Exports
module.exports = exports;
